import React from 'react';
import './footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import portfolioData from '../../portfolio.json';

export default function Footer() {
    const { footer } = portfolioData;

    const getIcon = (iconName) => {
        switch (iconName) {
            case 'instagram': return faInstagram;
            case 'linkedin': return faLinkedin;
            case 'github': return faGithub;
            default: return null;
        }
    };

    return (
        <footer className='footer'>
            <div className='footer__c-ontainer container'>
                <h1 className='footer__title'>{footer.title}</h1>

                <ul className='footer__list'>
                    {footer.links.map((link, index) => (
                        <li key={index}>
                            <a href={link.link} className='footer__link'>{link.name}</a>
                        </li>
                    ))}
                </ul>
                <div className='footer__social'>
                    {footer.social.map((item, index) => (
                        <a key={index} href={item.link} className='footer__social-icon' target='_blank' rel="noreferrer">
                            <FontAwesomeIcon icon={getIcon(item.icon)} />
                        </a>
                    ))}
                </div>
                <span className='footer__copy'>{footer.copy}</span>
            </div>
        </footer>
    )
}
